<template>
  <div class="wrap">
    <Head />
    <div class="part1">
      <p class="tit">数字资产工具包插件用户指南</p>
      <div class="img">
        <img
          src="../../../assets/images/pc/product/digitization/chrome-part.png"
          alt=""
        />
      </div>
      <div class="download">
        <a
          class="android"
          href="https://www.hwelltech.com/HWTool.zip"
          target="view_blank"
        >
          <span>数字资产工具包插件下载</span>
          <span class="version" v-if="chromeExtensionVersion"
            >V{{ chromeExtensionVersion }}</span
          >
        </a>
      </div>
    </div>
    <div class="part2">
      <div class="doc-content">
        <div class="par" id="par1">
          <h3 class="par-title">一、数字资产工具包插件的安装</h3>
          <div class="par-content">
            <p>
              1. 数字资产工具包插件（HWTool插件）的安装，点击本页“<a
                href="https://www.hwelltech.com/HWTool.zip"
                target="view_blank"
                >数字资产工具包插件下载</a
              >”按钮，下载最新的数字资产工具包插件安装包。
            </p>
            <p>2. 对下载的压缩包进行解压缩。</p>
            <img src="../../../assets/images/pc/product/chrome/1.png" alt="" />
            <p>
              3. 下载谷歌chrome浏览器，<a
                href="https://www.google.cn/chrome/"
                target="view_blank"
                >https://www.google.cn/chrome/</a
              >。下载完成后，安装chrome浏览器。
            </p>
            <p>
              4. 打开Chrome浏览器并单击右上角的“更多工具”，然后单击“扩展程序”。
            </p>
            <img src="../../../assets/images/pc/product/chrome/2.png" alt="" />
            <p>5. 开启开发者模式。</p>
            <img src="../../../assets/images/pc/product/chrome/3.png" alt="" />
            <p>
              6. 点击“加载已解压的扩展程序”，然后选择之前解压好的工具包文件夹。
            </p>
            <img src="../../../assets/images/pc/product/chrome/4.png" alt="" />
            <p>
              7.
              添加成功后，点击Chrome浏览器右上角“拼图”图标。选择“HWTool”，即可打开数字资产工具包插件。
            </p>
            <img src="../../../assets/images/pc/product/chrome/5.png" alt="" />
          </div>
        </div>
        <div class="par" id="par2">
          <h3 class="par-title">二、数字资产工具包插件的升级</h3>
          <div class="par-content">
            <p>
              1.
              进入数字资产工具包插件的首页，如果有新的版本升级，会弹出升级提示。点击“立即升级”会跳转到本页。
            </p>
            <img src="../../../assets/images/pc/product/chrome/6.png" alt="" />
            <p>
              2. 点击本页“<a
                href="https://www.hwelltech.com/HWTool.zip"
                target="view_blank"
                >数字资产工具包插件下载</a
              >”按钮，下载最新的数字资产工具包插件安装包。
            </p>
            <img src="../../../assets/images/pc/product/chrome/7.png" alt="" />
            <p>
              3.
              解压后，将文件夹里面的所有文件复制替换到，数字资产工具包插件之前安装的文件夹中（<span
                class="tips"
                >将之前安装文件夹里面所有子文件都先删除，安装文件夹不要更改文件名和移动位置，如果更改文件名或移动文件位置会导致插件不能正常使用以及数据丢失</span
              >）。
            </p>
            <img src="../../../assets/images/pc/product/chrome/8.png" alt="" />
            <p>
              4.
              点击chrome浏览器右上角拼图图标，管理扩展程序，打开扩展程序管理界面。
            </p>
            <img src="../../../assets/images/pc/product/chrome/9.png" alt="" />
            <p>
              5.
              找到数字资产工具包插件（HWTool）的扩展程序，点击刷新按钮。版本号发生变化，说明版本已经升级成功。（<span
                class="tips"
                >请一定保证新的安装包中的文件已经完整的复制进旧的安装文件夹，再点击刷新。不然可能导致插件无法正常更新使用</span
              >）
            </p>
            <img src="../../../assets/images/pc/product/chrome/10.png" alt="" />
          </div>
        </div>
        <div class="par" id="par3">
          <h3 class="par-title">三、数字资产工具包插件的使用</h3>
          <div class="par-content">
            <p>
              数字资产工具包插件的使用，请阅读<a
                href="https://apidocs.hwelltech.com/chrome-extensions-using"
                target="view_blank"
                >https://apidocs.hwelltech.com/chrome-extensions-using</a
              >文档。
            </p>
          </div>
        </div>
        <div class="par" ref="par4" id="par4">
          <h3 class="par-title">四、API的使用</h3>
          <div class="par-content">
            API的使用，请阅读以下文档
            <p>
              <a
                href="https://apidocs.hwelltech.com/chrome-extensions-query-api"
                target="view_blank"
                >https://apidocs.hwelltech.com/chrome-extensions-query-api</a
              >
            </p>
            <p>
              <a
                href="https://apidocs.hwelltech.com/chrome-extensions-transaction-api"
                target="view_blank"
                >https://apidocs.hwelltech.com/chrome-extensions-transaction-api</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
import axios from "axios";
export default {
  data() {
    return {
      chromeExtensionVersion: null, //chrome扩展程序版本
    };
  },
  components: {
    Head,
    Foot,
  },

  created() {},
  mounted() {
    this.getExtensionsConfig(); //获取chrome扩展程序版本信息
  },
  methods: {
    /*获取chrome扩展程序版本信息*/
    getExtensionsConfig() {
      let url =
        process.env.NODE_ENV == "development"
          ? `/api/extensionsConfig.json?time=${new Date().getTime()}`
          : `/extensionsConfig.json?time=${new Date().getTime()}`;

      axios
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.version)
              this.chromeExtensionVersion = res.data.version;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(550);
  background: linear-gradient(-30deg, #192F9C, #1185E9);
  position: relative;
  part1();
  padding-top: vw(60);

  .tit {
    margin-bottom: vw(25);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
  }

  .download {
    width: 80%;
    position: absolute;
    left: 50%;
    bottom: vw(20);
    transform: translateX(-50%);
    z-index: 10;

    .ios, .android {
      margin: 0 auto;
      height: vw(80);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 vw(20);
      border: 1px solid rgba(255, 255, 255, 0.6);
      border-radius: vw(80);

      i {
        width: vw(48);
        font-size: vw(48);
        color: #fff;
      }

      span {
        display: inline-block;
        font-size: vw(28);
        color: #fff;
      }

      .version {
        padding-left: vw(30);
        margin-left: vw(30);
        position: relative;

        &::before {
          content: '';
          width: 1px;
          height: 70%;
          background: #ffffff;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }

    .ios {
      margin-top: vw(40);
    }

    .android {
      margin-top: vw(40);
    }
  }

  .img {
    width: 45%;
    position: absolute;
    bottom: vw(90);
    text-align: center;
    left: 50%;
    transform: translateX(-50%);

    img {
      width: 100%;
    }
  }
}

.part2 {
  width: 100%;
  color: #666666;
  padding: vw(40) 0;
  background: #fff;
  word-wrap: break-word;
  word-break: break-all;

  .doc-content {
    padding: 0 vw(30);
    line-height: 1.8;

    .par {
      .par-title {
        color: #333333;
        margin-bottom: vw(10);
      }

      img {
        margin-top: vw(10);
      }

      .tips {
        font-weight: bold;
      }
    }
  }

  img {
    width: 100%;
  }
}
</style>
